import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { locationDataSelector } from '../../ducks/location-data'
import {
  contentSelector,
  departmentOfContentSelector,
  hidePriceModal,
  nameOfContentSelector,
} from '../../ducks/content'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import Advantages from '../../../common/Advantages'
import Description from '../../../common/Description'
import View from '../View'
import Bar from '../Bar'
import Loader from '../../../common/LoaderModule'
import Modal from '../../../common/Modal'
import Price from '../../../common/ProductPrice'
import { onPlatformSelector } from '../../ducks/onPlatform'

import styles from './product.module.scss'

function Product(props) {
  const {
    product: {
      singular: productName,
      title,
      condition,
      seo,
      reviews,
      priceList,
      view,
      editorPath,
      loading,
    },
    locationData,
    product,
    isActive,
    onPlatform,
    category,
    department,
  } = props

  return (
    <>
      {props.contentData.isPriceModalOpen && (
        <Modal
          isOpen={props.contentData.isPriceModalOpen}
          onRequestClose={props.hidePriceModal}
        >
          <Price title={title} priceList={priceList} className={styles.price} />
        </Modal>
      )}
      <div
        className={classNames(
          styles.root,
          (isActive || typeof isActive === `undefined`) && styles.rootActive
        )}
      >
        <Grid container className={styles.product}>
          <Grid
            item
            xs={12}
            md={5}
            className={classNames(loading && styles.viewLoading)}
          >
            <View
              loading={loading}
              productName={productName}
              src={view}
              alt={title}
              href={editorPath}
            />
          </Grid>
          <Grid item xs={12} md={7} className={styles.bar}>
            <Bar
              product={product}
              category={category}
              department={department}
              onPlatform={onPlatform}
            />
          </Grid>
          <Grid item xs={12} className={styles.advantages}>
            <Hidden smDown>
              <Advantages productName={productName} condition={condition} />
            </Hidden>
          </Grid>
        </Grid>
        <Grid container className={styles.description}>
          <Grid item xs={12}>
            <Description
              product={product}
              seo={seo}
              locationData={locationData}
              reviews={reviews}
              priceList={priceList}
              onPlatform={onPlatform}
            />
          </Grid>
        </Grid>
      </div>
    </>
  )
}

Product.propTypes = {
  product: PropTypes.object,
  isActive: PropTypes.bool,
  isPriceModalOpen: PropTypes.bool,
  locationData: PropTypes.object,
  onPlatform: PropTypes.string,
}

const mapStateToProps = (state) => ({
  locationData: locationDataSelector(state),
  contentData: contentSelector(state),
  onPlatform: onPlatformSelector(state),
  category: nameOfContentSelector(state),
  department: departmentOfContentSelector(state),
})

export default connect(mapStateToProps, { hidePriceModal })(Product)
